import React, { useEffect, useState } from 'react'
import { Input } from 'antd';
import { Formik, Field } from 'formik';

export const $FieldArrayInput = (props: any) => (
    <Field
        as={Input}
        {...props} />)